"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoute = exports.getPathname = void 0;
var getPathname = function (typeSafeUrl) {
    if (typeof typeSafeUrl === "string") {
        return typeSafeUrl;
    }
    else {
        return typeSafeUrl.route;
    }
};
exports.getPathname = getPathname;
var getSearchParams = function (query) {
    if (!query) {
        return "";
    }
    var params = new URLSearchParams(query).toString();
    return "?" + params;
};
var getRoute = function (typeSafeUrl) {
    if (typeof typeSafeUrl === "string") {
        return "" + typeSafeUrl;
    }
    var searchParams = getSearchParams(typeSafeUrl.query);
    var route = typeSafeUrl.route;
    var params = "params" in typeSafeUrl ? typeSafeUrl.params : {};
    Object.keys(params).forEach(function (param) {
        route = route.replace("[" + param + "]", params[param]);
    });
    var path = typeSafeUrl.path || "";
    return "" + route + path + searchParams;
};
exports.getRoute = getRoute;
//# sourceMappingURL=utils.js.map